export { pushAdClickData } from 'next-flight-server-reference-proxy-loader?id=70cc4f9027e1716017bb36afc5313ef211d2638b53&name=pushAdClickData!'